
/* styles */
require("!!../../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-38e39a5e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../../../vue-loader/lib/selector?type=styles&index=0!./rtSidebarMenuBody.vue")

var Component = require("!../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../vue-loader/lib/selector?type=script&index=0!./rtSidebarMenuBody.vue"),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/components/sidebarMenu/src/rtSidebarMenuBody.vue
// module id = 1937
// module chunks = 228